<template>
	<!-- Router view: handles all pages -->
	<router-view></router-view>
</template>

<script>
export default {
}
</script>

<style>
.max-width-container {
	max-width: 1400px;
	/* Maximális szélesség */
	margin: 0 auto;
	/* Középre igazítás */
}
</style>
